import React from "react"
import classnames from "classnames"
import PropTypes from "prop-types"
import _map from "lodash/map"

import ThemeConsumer from "shared/components/ThemeConsumer"
import Typograph from "components/Typograph/"

const TextInformartionBand = ({ infos, theme, sizeMax = 4, classNames }) => {
  const containerClasses = classnames(
    theme[`sizeMax_${sizeMax}`],
    theme.textInformartionBand,
    theme.pv3,
    theme.ph6,
    classNames
  )

  return (
    <dl className={containerClasses}>
      {_map(infos, ({ title, description }, index) => {
        const positionCurrent = index + 1
        const needMargin = positionCurrent > sizeMax
        const classesDescription = classnames({
          [theme.mt2]: needMargin
        })
        return (
          <span className={classesDescription}>
            <Typograph htmlTag="dt" size="small" color="outer_space">
              {title}
            </Typograph>
            <Typograph
              htmlTag="dd"
              size="small"
              color="outer_space"
              weight="bold"
            >
              {description}
            </Typograph>
          </span>
        )
      })}
    </dl>
  )
}

TextInformartionBand.propTypes = {
  infos: PropTypes.arrayOf(
    PropTypes.shape({
      infos: PropTypes.string,
      description: PropTypes.string
    })
  ),
  sizeMax: PropTypes.number,
  theme: PropTypes.shape({
    textInformartionBand: PropTypes.string,
    pv3: PropTypes.string,
    ph6: PropTypes.string,
    mt2: PropTypes.string
  }),
  classNames: PropTypes.string
}

export default ThemeConsumer("UITextInformartionBand")(TextInformartionBand)



// WEBPACK FOOTER //
// ./src/components/TextInformationBand/index.js